import React from 'react'
import { LuCheck } from 'react-icons/lu';
import ScheduleSummaryService from './ScheduleSummaryService';
import { formatDuration, formatPrice } from '../../../utils/pricing';
import styles from './scheduleSummary.module.css';

function ScheduleSummary({
    selectedServices = [],
    duration = 0,
    price = 0,
    staff = [],
    onToggleStaff = () => {},
    selectedStaffID,
}) {
    return (
        <div className={styles.summary}>
            <h1 className={styles.summaryTitle}>Appointment Summary</h1>
            <div className={styles.serviceList}>
                {selectedServices.map((service, index) => (
                    <ScheduleSummaryService key={index} service={service} />
                ))}
            </div>

            <div className={styles.totals}>
                <div className={styles.totalsLabel}>
                    <span>Total</span>
                    <span className={styles.totalsMeta}>
                        {selectedServices.length} {selectedServices.length === 1 ? 'service' : 'services'} · {formatDuration(duration)}
                    </span>
                </div>
                <span className={styles.totalsPrice}>{formatPrice(price)}</span>
            </div>

            <h2 className={styles.summarySubtitle}>Technician</h2>
            <div className={styles.staffList}>
                {staff.map((member) => {
                    const initials = member.name.split(' ').map((n) => n[0]).join('');
                    const isSelected = selectedStaffID === member.id;

                    return (
                        <button
                            key={member.id}
                            type="button"
                            aria-pressed={isSelected}
                            onClick={() => onToggleStaff(member)}
                            className={`${styles.staffMember}${isSelected ? ` ${styles.staffSelected}` : ''}`}
                        >
                            <span className={styles.avatar}>{initials}</span>
                            <span className={styles.staffName}>{member.name}</span>
                            <span className={styles.staffCheck} aria-hidden="true">
                                {isSelected && <LuCheck />}
                            </span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default ScheduleSummary
